import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AUTHGWCONSTANTS } from '../authorization/authconstatnts';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthHeaderInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const xenAuth = localStorage.getItem(AUTHGWCONSTANTS.xenAuth);
    const guestAuth = localStorage.getItem(AUTHGWCONSTANTS.guestAuth);

    let token = xenAuth || guestAuth;
    if (token === 'null' || token === 'undefined' || !token) {
      token = '';
    }

    const headers: { [name: string]: string } = {};

    if (token) {
      headers['XEN-AUTHORIZATION'] = token;
    }

    if (environment.platformInfo) {
      Object.assign(headers, environment.platformInfo);
    }

    const modifiedReq = request.clone({
      setHeaders: headers
    });

    return next.handle(modifiedReq);
  }
}
